
export default {
  name: 'PDPCommentButtons',
  props: {
    id: {
      type: Number,
      required: true,
    },
    upvoteCount: {
      type: Number,
      default: 0,
    },
    noReply: {
      type: Boolean,
      required: true,
    },
    isEmailVerified: {
      type: Boolean,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    helpfulBtnStartingState: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      helpfulBtnIsActive: this.helpfulBtnStartingState,
      initUpvoteCount: this.upvoteCount,
      likeCount: 0,
      maxLikeCount: 4,
    };
  },
  computed: {
    isMaxLikeCount() {
      return this.likeCount >= this.maxLikeCount;
    },
  },
  watch: {
    // Wait for response before changing helpfulBtnIsActive state
    upvoteCount() {
      // tl;dr: 'helpfulBtnIsActive' var controls the 'active' class which shows the user whether
      // the user has already toggled the 'helpful' btn for a comment
      // so,
      // if helpful btn starts active & upvote count != init count --> toggle 'active' class OFF
      // if helpful btn starts inactive & upvote count != init count --> toggle 'active' class ON
      const upvoteCountHasChanged = this.initUpvoteCount !== this.upvoteCount;
      this.helpfulBtnIsActive = upvoteCountHasChanged !== this.helpfulBtnStartingState;
    },
  },
  methods: {
    // Popover will not work if button is disabled
    upvoteComment() {
      if (this.isEmailVerified && !this.isMaxLikeCount) {
        this.$emit('update-action', { type: 'upvote', value: this.helpfulBtnIsActive });
        this.likeCount += 1;
      }
    },
    replyComment() {
      if (this.isEmailVerified) {
        this.$emit('reply-comment');
      }
    },
  },
};
